import request from '@/utils/request'

export function logisticsCode (data) {
  return request({
    url: '/card/api/change_card_log/logisticsCode',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/card/api/logistics_code.js